const TARGET_BYTES = 500 * 1024;
const MAX_BYTES = 2 * 1024 * 1024;
const MAX_EDGE = 800;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not read image'));
    };
    image.src = url;
  });
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}

async function compressStoreLogo(file) {
  if (
    !file.type ||
    file.type.indexOf('image/') !== 0 ||
    file.type === 'image/gif'
  ) {
    return file;
  }
  if (file.size <= TARGET_BYTES) {
    return file;
  }

  const image = await loadImage(file);
  let width = image.width;
  let height = image.height;
  const longest = Math.max(width, height);
  if (longest > MAX_EDGE) {
    const scale = MAX_EDGE / longest;
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0, width, height);

  const isPng = file.type === 'image/png';
  const outputType = isPng ? 'image/png' : 'image/jpeg';
  let quality = 0.92;
  let blob = await canvasToBlob(canvas, outputType, quality);
  while (blob && blob.size > TARGET_BYTES && quality > 0.7 && !isPng) {
    quality -= 0.07;
    blob = await canvasToBlob(canvas, outputType, quality);
  }
  if (!blob || blob.size >= file.size) {
    return file;
  }

  const extension = isPng ? '.png' : '.jpg';
  const name = file.name.replace(/\.[^.]+$/, '') + extension;
  return new File([blob], name, { type: outputType });
}

async function submitStoreLogoPlaceholder(input) {
  const file = input.files && input.files[0];
  if (!file || !input.form) return;

  const hint = input.form.querySelector('[data-logo-hint]');
  const originalHint = hint ? hint.textContent : '';
  if (hint) hint.textContent = 'Uploading…';

  let uploadFile = file;
  try {
    uploadFile = await compressStoreLogo(file);
  } catch (error) {
    uploadFile = file;
  }

  if (uploadFile.size > MAX_BYTES) {
    if (hint) hint.textContent = 'Use an image under 2 MB';
    input.value = '';
    window.setTimeout(() => {
      if (hint) hint.textContent = originalHint;
    }, 4000);
    return;
  }

  if (uploadFile !== file) {
    const transfer = new DataTransfer();
    transfer.items.add(uploadFile);
    input.files = transfer.files;
  }
  input.form.submit();
}

window.submitStoreLogoPlaceholder = submitStoreLogoPlaceholder;
